import React from 'react';
import { Button } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { ThreeDotMenu } from 'common/components/ThreeDotMenu';
import { IContract } from 'entities/Contract/Contract.models';
import { ISeller } from 'entities/Seller/Seller.models';
import { IAccount } from 'entities/Account/Account.models';

const getContractName = (contract: IContract | null) => {
  return contract ? `${contract.sellerName} - ${contract.buyerName}` : '';
};

export const renderContractListForSuperAdminRecords = (onDeleteClick: (id: number) => void) => {
  return [
    {
      key: 'sellerName',
      render: (_, record) => getContractName(record),
    },
    {
      key: 'menu',
      render: (_, record) => {
        return (
          <ThreeDotMenu
            items={[
              {
                key: 'delete',
                label: <Button onClick={() => onDeleteClick(record.id)}>Удалить</Button>,
                className: 'delete',
              },
            ]}
          />
        );
      },
      width: 64,
    },
  ] as ColumnsType<IContract>;
};

export const listDataToAddContractSelectOptions = (data: (ISeller | IAccount)[]) =>
  data.map((item) => ({ label: item.name, value: item.id }));
